import { render, staticRenderFns } from "./MobileMoneyComponent.vue?vue&type=template&id=b8d651f8&"
import script from "./MobileMoneyComponent.vue?vue&type=script&lang=js&"
export * from "./MobileMoneyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports